import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ExamPeriod, ExamPeriodMonitorState } from "@types";

export const useReopenExamInstance = (examPeriod?: ExamPeriod) => {
    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const reopen = async (id: string) => {
        try {
            const response = await axios.post(`/api/examinstance/monitor/${id}/reopen`);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.reopenExamInstance"));
        }
    };

    return useMutation({
        mutationFn: reopen,
        onSuccess: (_, id) => {
            if (examPeriod?.id) {
                queryClient.setQueryData(["examPeriods", examPeriod.id, "monitor"], (old: any) =>
                    old?.map((item: any) =>
                        item.id === id ? { ...item, state: ExamPeriodMonitorState.InProgress } : item
                    )
                );
            }
        },
        onSettled: () => {
            if (examPeriod?.id) {
                queryClient.refetchQueries({ queryKey: ["examPeriods", examPeriod.id, "monitor"] });
                queryClient.invalidateQueries({ queryKey: ["examPeriods", examPeriod.id] });
            }
        },
    });
};
